import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import countryRegionData from '@/assets/data/countryRegion.json';

Vue.use(VueAxios, axios)

const state = {
  countryList: countryRegionData,
  monthList: [
    {
      name: 'January',
      value: '01'
    },
    {
      name: 'Feburary',
      value: '02'
    },
    {
      name: 'March',
      value: '03'
    },
    {
      name: 'April',
      value: '04'
    },
    {
      name: 'May',
      value: '05'
    },
    {
      name: 'June',
      value: '06'
    },
    {
      name: 'July',
      value: '07'
    },
    {
      name: 'August',
      value: '08'    
    },
    {
      name: 'September',
      value: '09'
    },
    {
      name: 'October',
      value: '10'
    },
    {
      name: 'November',
      value: '11'
    },
    {
      name: 'December',
      value: '12'
    }
  ]
}

const getters = {
  getCountryList: state => state.countryList,
  getMonthList: state => state.monthList,
}

const mutations = {
}

const actions = {
}


export default {
  state,
  mutations,
  getters,
  actions
}